import { render, staticRenderFns } from "./goods-detail.vue?vue&type=template&id=a8d2653a&scoped=true&"
import script from "./goods-detail.vue?vue&type=script&lang=js&"
export * from "./goods-detail.vue?vue&type=script&lang=js&"
import style0 from "./goods-detail.vue?vue&type=style&index=0&id=a8d2653a&prod&scoped=true&lang=less&"
import style1 from "./goods-detail.vue?vue&type=style&index=1&id=a8d2653a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d2653a",
  null
  
)

export default component.exports